var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clipboard-button"},[_c('icon-button',{attrs:{"icon":_vm.icon,"tooltip":_vm.tooltip,"size":_vm.size},on:{"click":_vm.handleCopy}}),_vm._v(" "),_c('div',{staticClass:"copy-status"},[(_vm.success)?_c('success-icon'):_vm._e(),_vm._v(" "),(_vm.error)?_c('error-icon'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }